<template>
    <div class='page_home'>
         <div id='page-top' style='height: 80px'></div> 
        <div class='banner'>
            <swiper :options="swiperOption">
                <swiper-slide class='banner1'>
                    <div>
                        <h2>致力于为经销商集团</h2>
                        <!-- <h2></h2> -->
                        <h2>拓展二手车业务提供服务</h2>
                        <span></span>
                        <p>拉风汽车依托专业的二手车评估技术、强大的风控体系、数据模型以及监控措施，提供数据挖掘及整合处理技术，帮助其提高效率并降低运营成本</p>
                        <img src="../assets/imgs/banner2.png" alt="">
                    </div>
                </swiper-slide>
                <swiper-slide class='banner2'>
                    <div>
                        <h2>致力于为金融机构</h2>
                        <h2>开拓二手车金融业务提供服务</h2>
                        <span></span>
                        <p @click='download'>了解详情</p>
                        <img src="../assets/imgs/banner4.png" alt="">
                    </div>
                </swiper-slide>
                <swiper-slide class='banner3'>
                    <div class='banner-img'>
                        <h2>拉风汽车已覆盖全国50个城市、700余家4s店</h2>
                        <img src="../assets/imgs/banner-03@1x.png">
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            
            <assess-item id='assess'></assess-item>
        </div>
        <div class='title'>
            <ul>
                <li>
                    <img src="../assets/images/assicon.png" alt="">
                    <span>更精准的二手车评估能力</span>
                </li>
                <li>
                    <img src="../assets/images/controlicon.png" alt="">
                    <span>更安全便捷的风控手段</span>
                </li>
                <li>
                    <img src="../assets/images/customicon.png" alt="">
                    <span>更强大的定制开发能力</span>
                </li>
            </ul>
        </div>
        <div class='home_intro'>
            <ul>
                <li>
                    <h3>一站式汽车金融服务平台</h3>
                    <p class='bor dis'><span class='borl'></span><span></span><span class='borr'></span></p> 
                    <div class='join'>
                        <div class='sp'>
                            <img class='sp_bg_img' src="../assets/imgs/img_sp.jpg" alt="">
                            <div>
                                <img src="../assets/imgs/ic_sp.png" alt="">
                                <small></small>
                                <span>为金融机构提供服务</span>
                                <p>对接大型经销商集团等优质客户。<br/>贷中监管、贷后催收。</p>
                                <span class='button' @click="oldcar = true">点击申请</span>
                            </div>
                        </div>
                        <div class='jxs'>
                            <img class='sp_bg_img' src="../assets/imgs/img_jingxiaoshang.jpg" alt="">
                            <div>
                                <img src="../assets/imgs/ic_jingxiaoshang.png" alt="">
                                <small></small>
                                <span>为经销商提供服务</span>
                                <p>精准评估，二手车非标资产标准化。<br/>业务以库存金融为主，消费金融为辅。</p>
                                <span class='button' @click="dealer = true">点击申请</span>
                            </div>
                        </div>
                    </div>
                </li>
                <!-- <li>
                    <h3></h3>
                    <p class='bor dis'><span  class='borl'></span><span></span><span class='borr'></span></p>
                    <div class='xfjr'>
                        <div class='consume right'>
                            <h5>加盟申请</h5>
                            <el-form ref="consumeForm" :model="consumeForm" :rules="consume">
                                <el-form-item prop='name'>
                                    <el-input placeholder='公司名称' v-model='consumeForm.name'></el-input>
                                </el-form-item>
                                <el-form-item prop='linkman'>
                                    <el-input placeholder='联系人' v-model='consumeForm.linkman'></el-input>
                                </el-form-item>
                                <el-form-item prop='phone'>
                                    <el-input placeholder='手机号码' v-model.number='consumeForm.phone'></el-input>
                                </el-form-item>
                                <el-form-item prop='region'>
                                    <el-input placeholder='经营区域(**省**市)' v-model='consumeForm.region'></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="danger" @click='subConsume()'>立即申请</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <img src="../assets/imgs/img_xiaofeijinrong.png" alt="">
                    </div>
                    <div class='download' id="downloadApp">
                        <div>
                            <h3>二手车远程AI评估系统</h3>
                            <span class="border"></span>
                            <small>下载拉风汽车ios客户端／安卓客户端</small>
                            <el-popover ref="iosshow" placement="right" :width="qrdW.width" trigger="click">
                                <img src="../assets/imgs/qrd_ios.png" alt="" class='adqrd' :style='qrdW'>
                            </el-popover>
                            <p class='ios' v-popover:iosshow>拉风汽车ios客户端</p>
                            <el-popover ref="adshow" placement="right" :width="qrdW.width" trigger="click">
                                <img src="../assets/imgs/qrd_ad.png" alt="" class='adqrd' :style='qrdW'>
                            </el-popover>
                            <p class='ad' v-popover:adshow>拉风汽车安卓客户端</p>
                            
                        </div>
                    </div>
                </li> -->
                <li>
                    <h3>合作伙伴</h3>
                    <p class='bor'><span class='borl'></span><span>互惠互利 精诚合作</span><span class='borr'></span></p>
                    <div>
                        <ul class='join-work'>
                            <li  v-for="fellow in fellows" :key="fellow.hover">
                                <img :src="fellow.pub" alt="">
                                <img :src="fellow.hover" alt="">
                            </li>
                        </ul>
                    </div> 
                </li>
            </ul>
        </div>
        <div class='oldcar'>
            <el-dialog :visible.sync="oldcar" class="dialog">
                <div class='formTitle'>
                    <h1>二手车经销商加盟</h1>
                    <span>(<small>*</small>号为必填项)</span>
                </div>
                <el-form :model="oldcarForm" :rules="oldcars" ref="oldcarForm"  label-width="5px">
                    <el-form-item prop="name" label=' '>
                        <el-input v-model="oldcarForm.name" placeholder='公司名称'></el-input>
                    </el-form-item>
                    <el-form-item prop="linkman" label=' '>
                        <el-input v-model="oldcarForm.linkman" placeholder='联系人'></el-input>
                    </el-form-item>
                    <el-form-item prop="phone" label=' '>
                        <el-input v-model.number="oldcarForm.phone" placeholder='手机号'></el-input>
                    </el-form-item>
                    <el-form-item prop="eml" label=' '>
                        <el-input v-model="oldcarForm.eml" placeholder='邮箱'></el-input>
                    </el-form-item>
                    <el-form-item prop="region" label=' '>
                        <el-input v-model="oldcarForm.region" placeholder='销售区域(**省**市)' class="show"></el-input>
                    </el-form-item>
                    <el-form-item prop="remark" label=' '>
                        <el-input type="textarea" v-model="oldcarForm.remark" placeholder="备注"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="danger" @click="subOldCar()">立即申请</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
        <div class="dealer">
            <el-dialog :visible.sync="dealer" class="dialog">
                <div class='formTitle'>
                    <h1>经销商集团合作申请</h1>
                    <span>(<small>*</small>号为必填项)</span>
                </div>
                <el-form :model="dealerForm" label-width="5px" :rules="dealers" ref="dealerForm">
                    <el-form-item label=" " prop="name">
                        <el-input v-model="dealerForm.name" placeholder="公司名称"></el-input>
                    </el-form-item>
                    <el-form-item label=" " prop="store">
                        <el-input v-model.number="dealerForm.store" placeholder="店面数量"></el-input>
                    </el-form-item>
                    <el-form-item label=" " prop="brand">
                        <el-input v-model="dealerForm.brand" placeholder="主营品牌"></el-input>
                    </el-form-item>
                    <el-form-item prop="region" label=' '>
                        <el-input v-model="dealerForm.region" placeholder='销售区域(**省**市)' class="show"></el-input>
                    </el-form-item>
                    <el-form-item label=" " prop="linkman">
                        <el-input v-model="dealerForm.linkman" placeholder="联系人"></el-input>
                    </el-form-item>
                    <el-form-item label=" " prop="phone">
                        <el-input type="phone" v-model.number="dealerForm.phone" placeholder="手机号"></el-input>
                    </el-form-item>
                    <el-form-item label=" " prop="eml">
                        <el-input v-model="dealerForm.eml" placeholder="邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label=" " prop="remark">
                        <el-input type="textarea" v-model="dealerForm.remark" placeholder="备注"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="danger" @click="subDealer()">立即申请</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import zhongyin1 from '../assets/imgs/zhongyin-1.png'
    import zhongyin2 from '../assets/imgs/zhongyin-2.png'
    import zhaoshang1 from '../assets/imgs/zhaoshang-1.png'
    import zhaoshang2 from '../assets/imgs/zhaoshang-2.png'
    import youli1 from '../assets/imgs/youli-1.png'
    import youli2 from '../assets/imgs/youli-2.png'
    import anbang1 from '../assets/imgs/anbang-1.png'
    import anbang2 from '../assets/imgs/anbang-2.png'
    import futian1 from '../assets/imgs/futian-1.png'
    import futian2 from '../assets/imgs/futian-2.png'
    import beiqi1 from '../assets/imgs/beiqi-1.png'
    import beiqi2 from '../assets/imgs/beiqi-2.png'
    import rundong1 from '../assets/imgs/rundong-1.png'
    import rundong2 from '../assets/imgs/rundong-2.png'
    import wzqc1 from '../assets/images/wzqc-01.png'
    import wzqc2 from '../assets/images/wzqc-02.png'
    import jyg1 from '../assets/images/jyg-01.png'
    import jyg2 from '../assets/images/jyg-02.png'
    import assessItem from '@/components/assessItem'
    export default {
        data() {
            return {
                qrdW: {
                    width: '150px'
                },
                swiperOption: {
                    pagination: '.swiper-pagination',
                    autoplay:3000,
                    autoHeight:true,
                    loop:true,
                    direction : 'vertical',
                },
                fellows: [
                    {
                        pub: zhaoshang1,
                        hover: zhaoshang2
                    }, {
                        pub: youli1,
                        hover: youli2
                    }, {
                        pub: anbang1,
                        hover: anbang2
                    }, {
                        pub: futian1,
                        hover: futian2
                    }, {
                        pub: beiqi1,
                        hover: beiqi2
                    }, {
                        pub: rundong1,
                        hover: rundong2
                    }, {
                        pub: wzqc1,
                        hover: wzqc2
                    }, {
                        pub: jyg1,
                        hover: jyg2
                    }
                ],
                oldcar: false,
                dealer: false,
                consumeForm: {
                    name: '',
                    linkman: '',
                    phone: '',
                    region: ''
                },
                consume: {
                    name: [
                        { required: true, message: '请输入公司名称'},
                    ],
                    region: [
                        { required: true, message: '请输入经营区域'}
                    ],
                    linkman: [
                        { required: true, message: '请输入联系人'}
                    ],
                    phone: [
                        { required: true, message: '请输入手机号'},
                        { type: 'number', message: '手机号必须为数字'}
                    ]
                },
                oldcarForm: {
                    name: '',
                    linkman: '',
                    eml: '',
                    region: '',
                    phone: '',
                    remark: ''
                },
                oldcars: {
                    name: [
                        { required: true, message: '请输入公司名称'},
                    ],
                    region: [
                        { required: true, message: '请输入销售区域'}
                    ],
                    linkman: [
                        { required: true, message: '请输入联系人'}
                    ],
                    eml: [
                        { required: true, message: '请输入邮箱'},
                        { type: 'email', message: '请输入正确的邮箱地址'}
                    ],
                    phone: [
                        { required: true, message: '请输入手机号'},
                        { type: 'number', message: '手机号必须为数字'}
                    ]
                },
                 dealerForm: {
                    name: '',
                    brand: '',
                    linkman: '',
                    eml: '',
                    store: '',
                    region: '',
                    phone: '',
                    remark: ''
                },
                dealers: {
                    name: [
                        { required: true, message: '请输入公司名称'},
                    ],
                    brand: [
                        { required: true, message: '请输入主营品牌'},
                    ],
                    region: [
                        { required: true, message: '请输入销售区域'}
                    ],
                    linkman: [
                        { required: true, message: '请输入联系人'}
                    ],
                    eml: [
                        { required: true, message: '请输入邮箱'},
                        { type: 'email', message: '请输入正确的邮箱地址' }
                    ],
                    store: [
                        { required: true, message: '请输入店面数量'},
                        { type: 'number', message: '店面数量必须为数字'}
                    ],
                    phone: [
                        { required: true, message: '请输入手机号'},
                        { type: 'number', message: '手机号必须为数字'}
                    ]
                }
            }
        },
        components: {
          assessItem
        },
        methods: {
            download(){
               this.$router.push({name:'Business'})
            },
            join(){
                this.show = true;
                this.show2 = false;
            },
            subOldCar() {
                var that = this;
                that.$refs['oldcarForm'].validate((valid) => {
                    if (valid) {
                        that.$http.post('http://www.la-feng.com:9020/input/spadd',JSON.stringify(that.oldcarForm)).then(function(msg){
                            that.$message.success("提交成功");
                            that.$refs['oldcarForm'].resetFields();
                        },function(err){
                            console.log(err)
                            that.$message.error("提交失败")
                        });
                    } else {
                        return false;
                    }
                });
            },
            subDealer() {
                var that = this;
                that.$refs['dealerForm'].validate((valid) => {
                    if (valid) {
                        that.$http.post('http://www.la-feng.com:9020/input/agencyadd',JSON.stringify(that.dealerForm)).then(function(msg){
                            that.$message.success("提交成功");
                            that.$refs['dealerForm'].resetFields();
                        },function(err){
                            console.log(err)
                            that.$message.error("提交失败")
                        });
                    } else {
                        return false;
                    }
                });
            },
            subConsume() {
                var that = this;
                that.$refs['consumeForm'].validate((valid) => {
                    if (valid) {
                        that.$http.post('http://www.la-feng.com:9020/input/cfadd',JSON.stringify(that.consumeForm)).then(function(msg){
                            that.$message.success("提交成功");
                            that.$refs['consumeForm'].resetFields();
                        },function(err){
                            console.log(err);
                            that.$message.error("提交失败")
                        });
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style lang="scss">
    .page_home {
        .bor{
            position:relative;
            text-align:center;
            vertical-align:middle;
            &.dis {
                opacity: 0
            }
            .borl{
                display:inline-block;
                position:absolute;
                top:17px;
                left:0;
                right:1000px;
                height:1px;
                background-color:#ececec;
            }
            .borr{
                display:inline-block;
                position:absolute;
                top:17px;
                right:0;
                left:1000px;
                height:1px;
                background-color:#ececec;
            }
        }
        background:#fff;
        text-align:left;
        .banner {
            position: relative;
        }
        .banner,.swiper-container{
            height:560px;
            // min-width:1200px;
            width: 100%;
            .banner1{
                background:url('../assets/imgs/banner1.jpg') no-repeat;
                p{
                    width:480px;
                }
            }
            .banner2{
                background:url('../assets/imgs/banner3.jpg') no-repeat;
                p{
                    width:200px;
                    text-align:center;
                    border:1px solid #fff;
                    padding:10px 0;
                    display:inline-block;
                    margin-top:40px;
                    cursor:pointer;
                }
            }
            .banner3 {
                background:url('../assets/imgs/nbanner_03.jpg') no-repeat;
                h2 {
                    margin-top: 250px;
                    position: relative;
                    z-index: 1;
                }
                .banner-img {
                    img {
                        left: 0;
                        top: -130px;
                        width: 700px;
                        height: auto;
                    }
                }
            }
            .swiper-slide{
                background-size:100% 560px;
                height:560px;
                div{
                    width:75%;
                    position:relative;
                    margin:0 auto;
                    color:#fff;
                    margin-top:130px;
                    min-width:1088px;
                    img{
                        position:absolute;
                        top:-80px;
                        right:16px;
                        width:567px;
                        height:488px;
                    }
                    h1{
                        font-size: 32px;
                        line-height: 59px;
                        font-weight:normal;
                    }
                    h2{
                        font-size: 38px;
                        line-height: 59px;
                        font-weight:normal;
                        // opacity:0.84;
                        letter-spacing: 0;
                    }
                    span{
                        display:block;
                        width:76px;
                        border-top:2px solid #fff;
                        margin:19px 0 25px;
                    }
                    p{
                        font-size: 18px;
                        color: #FFFFFF;
                        letter-spacing: 0;
                        line-height: 28px;
                    }
                }
            }
            .swiper-pagination{
                margin-right:8%;
                span{
                    background: rgba(255,255,255,0.60);
                }
                .swiper-pagination-bullet-active{
                    background: #ED345A;
                }
            }
        }
        .oldcar,.dealer{
            .el-dialog__header{
                padding:15px 15px 0;
                .el-dialog__close{
                   color:#ff3b30; 
                }
            }
            .formTitle{
                margin-bottom:29px;
                h1{
                    font-size: 26px;
                    color: #000000;
                    letter-spacing: 0;
                    font-weight:normal;
                    line-height:37px;
                }
                span{
                    font-size: 17px;
                    color: rgba(0,0,0,0.38);
                    letter-spacing: 0;
                    line-height:26px;
                    small{
                        color:#ff3b30;
                        font-size: 19px;
                        vertical-align: middle;
                    }
                }
            }
            .el-dialog{
                width:750px;
                text-align:center;
                .el-form-item{
                    padding:0 110px;
                    .el-form-item__content{
                        width:495px;
                        
                        text-align:left;
                    }
                    .el-input{
                        height:52px;
                    }
                    .el-textarea>textarea{
                        min-height:52px;
                    }
                    .el-input,.el-textarea{
                        width:95%;
                        .el-input__inner{
                            line-height: 52px;
                        }
                        .el-input__inner,.el-textarea__inner{
                            background: #F8F8F9;
                            height:52px;
                            border: 1px solid #ECECEC;
                            border-radius: 3px;
                            font-size: 14px;
                        }
                    }
                    label{
                        float:right;
                        height:52px;
                        padding:19px 0 0 14px; 
                    }
                    .el-button{
                        width:476px;
                        height:52px;
                        border-radius:99px;
                        background:#FF3B30;
                        color:#fff;
                        font-size:17px;
                        margin-top:20px;
                    }
                }
            }
        }
        .title{
            width:100%;
            height:220px; 
            background: #F5F9FC;
            padding:0 12%;
            ul{
                height:100%;
                display: flex;
                justify-content: space-between;
                li{
                    display:inline-block;
                    width:33.33%;
                    height:100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    &:hover{
                        background: #FFFFFF;
                        border-bottom:2px  solid #FF3B30;
                        box-shadow: 0 2px 6px 0 rgba(206,206,206,0.50);
                    }
                    img {
                        width: 72px;
                    }
                    span{
                        display:block;
                        opacity:0.8;
                        font-size: 18px;
                        margin-top: 24px;
                    }
                }
            }
        }
        .home_intro{
            ul{
                li{
                    h3{
                        margin-top:89px;
                        text-align:center;
                        opacity: 0.8;
                        font-size: 32px;
                        color: #222328;
                        letter-spacing: 0;
                        line-height: 36px;
                        font-weight:normal;
                    }
                    p{
                        opacity: 0.38;
                        font-size: 24px;
                        color: #000000;
                        line-height: 34px;
                        margin:24px 12% 70px;
                    }
                    .join{
                        font-size:0;
                        text-align:center;
                        .sp,.jxs{
                            width:544px;
                            height:390px;
                            display:inline-block;
                            position:relative;
                            .sp_bg_img{
                                width:100%;
                                height:100%;
                            }
                            div{
                                width:100%;
                                height:100%;
                                position:absolute;
                                top:0;
                                left:0;
                                padding-top:106px;
                                transition:all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                                &:hover{
                                    background:rgba(255,59,48,0.8);
                                    padding-top:61px;
                                    small{
                                        opacity:0;
                                        margin:0 auto;
                                    }
                                    p{
                                        opacity:1;
                                    }
                                }
                                small{
                                    display:block;
                                    margin:30px auto;
                                    width:50px;
                                    border-top:2px solid #fff;
                                    transition:all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                                }
                                span{
                                    display:block;
                                    font-size: 24px;
                                    color: #FFFFFF;
                                    line-height: 34px;
                                    transition:all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                                }
                                p{
                                    font-size:16px;
                                    color:#fff;
                                    opacity:0;
                                    margin:0;
                                    margin-bottom:35px;
                                    transition:all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                                    padding:0 108px 0 106px;
                                }
                                .button{
                                   font-size:16px; 
                                   height:46px;
                                   width:150px;
                                   margin:0 auto;
                                   border:1px solid #fff;
                                   line-height:46px;
                                   cursor:pointer;
                                }
                            }
                        }
                    }
                    .xfjr{
                        width:60%;
                        min-width:1028px;
                        margin:0 auto 67px;
                        .consume{
                            padding:26px 50px;
                            width:460px;
                            height:400px;
                            border: 1px solid #EFF0F4;
                            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.05);
                            h5{
                                font-size: 21px;
                                font-weight:normal;
                                color: #000000;
                                letter-spacing: 0;
                                margin-bottom:24px;
                            }
                            .el-form{
                                .el-form-item__content{
                                    line-height:normal;
                                }
                                text-align:center;
                                .el-input{
                                    .el-input__inner{
                                        background: #F8F8F9;
                                        border: 1px solid #ECECEC;
                                        border-radius: 3px;
                                    }
                                }
                                .el-select{
                                    display:block;
                                    outline:0;
                                }
                                .el-button{
                                    width:196px;
                                    height:40px;
                                    border-radius:99px;
                                    background:#FF3B30;
                                    color:#fff;
                                }
                            }
                        }
                    } 
                    .download{
                        background:url('../assets/imgs/img_download.jpg') no-repeat center;
                        background-size:100%;
                        height:477px;
                        min-width:1088px;
                        padding:124px 0 0 176px;
                        div{
                            width:400px;
                            text-align:center;
                            color:#fff;
                            h3{
                                font-size: 32px;
                                color: #FFFFFF;
                                letter-spacing: 0;
                                line-height: 36px;
                                margin:0;
                            }
                            .border{
                                display:block;
                                width:118px;
                                border-top:2px solid #fff;
                                margin:16px auto 14px;
                            }
                            small{
                                display:inline-block;
                                font-size: 21px;
                                line-height: 21px;
                                margin-bottom:62px;
                            }
                            p{
                                text-align:left;
                                display:inline-block;
                                border: 1px solid rgba(255,255,255,0.54);
                                border-radius: 2px;
                                width:214px;
                                padding:0;
                                padding-left:54px;
                                height:42px;
                                font-size: 16px;
                                color:#fff;
                                line-height: 42px;
                                opacity:1;
                                margin-top:0px;
                                margin-bottom:16px;
                                cursor:pointer;
                                position:relative;
                            }
                            .ad{
                                background:url('../assets/imgs/img_android_white.png') no-repeat 12px center;
                            }
                            .ios{
                                background:url('../assets/imgs/img_ios_white.png') no-repeat 12px center;
                            }
                        }
                    }
                    ul.join-work{
                        margin:0 auto;
                        width:75%;
                        display: flex;
                        flex-wrap: wrap;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        li{
                            width: 185px;
                            margin: 0 32px;
                            margin-bottom: 84px;
                            text-align: center;
                            cursor: pointer;
                            &:hover{
                                img:first-child{
                                    display: none;
                                }
                                img:last-child{
                                    display:inline-block;
                                }
                            }
                            img:last-child{
                                display: none;
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Home.vue?08781949